import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change, FieldArray, reduxForm } from 'redux-form';

import { Typography } from '@material-ui/core';


import BookingInformation from '../booking-information/BookingInformation';

import useStyles from './styles';

const initialValues = {
  mandatoryFees: []
};

const MandatoryFees = ({
  accommodationData,
  widgetForm,
  changeFormFieldValue,
  handleSubmit
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const currency = widgetForm.values.currency;

  React.useEffect(() => {
    setmandatoryFees(accommodationData);
  }, [accommodationData]);

  const setmandatoryFees = accommodation => {
    const receivedmandattoryFees = accommodation.mandatoryFeesForm.mandatoryFees;
    const createdmandatoryFees = widgetForm.values.mandatoryFeess;

    if (createdmandatoryFees && createdmandatoryFees.length) return;

    const mandatoryFeesList = receivedmandattoryFees.map(item => {
      return {
        ...item,
        value: 0
      };
    });

    changeFormFieldValue('mandatoryFees', mandatoryFeesList);
  };
  return (
    <div className={classes.wrapper}>
  
        <BookingInformation data={accommodationData} form={widgetForm} />
    
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default reduxForm({
  form: 'widgetForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(MandatoryFees));
